export default `
  mutation handlePaymentSuccess($input: HandlePaymentSuccessInput!) {
    handlePaymentSuccess(input: $input) {
      success
      message
    }
  }
`
